import moment from "moment";
import { TABLE_DATE_FORMAT } from "./Constants";

/**
 * Format a timestamp or date value for table display.
 *
 * @param {string|number|Date} value - The date value to format.
 *   If the value is a 10-digit timestamp it is treated as seconds,
 *   otherwise it is treated as milliseconds or a date string.
 * @returns {string} Formatted date string or "-" when no value is provided.
 */
export const formatTableDate = (value) => {
    if (!value) return "-";

    const timestamp =
        String(value).length === 10
            ? Number(value) * 1000
            : Number(value);

    return moment(timestamp).format(TABLE_DATE_FORMAT);
};



export const formatDuration = (startDate, endDate) => {
  let start = moment(startDate);
  let end = moment(endDate);

  let negative = false;
  const startUnix = start.unix();
  const endUnix = end.unix();
  if (startUnix > endUnix) {
    negative = true;
    [start, end] = [end, start];
  }

  const years = end.diff(start, "years");
  start.add(years, "years");

  const months = end.diff(start, "months");
  start.add(months, "months");

  const days = end.diff(start, "days");

  const weeks = Math.floor(days / 7);
  const remainingDays = days % 7;

  const result = [
    years && `${years}y`,
    months && `${months}m`,
    weeks && `${weeks}w`,
    remainingDays && `${remainingDays}d`,
  ]
    .filter(Boolean)
    .join(", ");

  if (!result) {
    return "0d";
  }

  return `${negative ? "-" : ""}${result}`;
};

